module.exports = __webpack_public_path__ + "b09d577bcf39dac3fd268971f551a577.png";